/** @jsxImportSource @emotion/react */
import Calls from "@/components/admin/Calls";
import ConsultProcess from "@/components/admin/ConsultProcess";
import DownloadDocuments from "@/components/admin/DownloadDocuments";
import EmailBlacklist from "@/components/admin/EmailBlacklist";
import HistoryProcess from "@/components/admin/HistoryProcess";
import Integrations from "@/components/admin/Integrations";
import UploadDocuments from "@/components/admin/UploadDocuments";
import { ActivePasswordForm } from "@/components/forms/ActivePasswordForm";
import { ChangePasswordForm } from "@/components/forms/ChangePasswordForm";
import { ForgotPassword } from "@/components/forms/ForgotPasswordForm";
import IdForm from "@/components/forms/idForm/IdForm";
import { UserPasswordForm } from "@/components/forms/UserPasswordForm";
import HomePage from "@/components/Home";
import { InternalList } from "@/components/InternalList";
import { NovaventaLayout } from "@/components/NovaventaLayout";
import { SelfRegistrationLogin } from "@/components/SelfRegistrationLogin";
import { usePrismic } from "@/hooks/usePrismic";
import ExpertCall from "@/modules/ExpertCall/ExpertCall";
import MenuAdmin from "@/modules/management/MenuAdmin";
import Registration from "@/modules/Registration/Registration";
import SelfRegistration from "@/modules/selfRegistration/SelfRegistration";
import { CreditOnDemand } from "@/pages/creditOnDemand";
import { DigitalRegistrationPage } from "@/pages/DigitalRegistrationPage";
import ExpertCallLogin from "@/pages/expertCall/expertCallLogin";
import ProspectCustomerForm from "@/pages/expertCall/ProspectCustomerForm";
import { PaymentMethod } from "@/pages/PaymentMethod";
import { RetakesCredit } from "@/pages/retakesCredit";
import { UploadImagePage } from "@/pages/UploadImagePage";
import { WelcomeToNovaventa } from "@/pages/WelcomeToNovaventa";
import { device } from "@/utils/NovaventaMedia";
import { BrowserRouter, Navigate, Route, Routes } from "react-router";

export const RoutesApp = () => {
  const t = usePrismic();

  return (
    <BrowserRouter>
      <Routes>
        <Route index element={<HomePage />} />

        <Route path="auto-gestion">
          <Route index element={<Navigate to="/auto-gestion/login-documento" />} />
          <Route
            path="login-documento"
            element={
              <SelfRegistration>
                <SelfRegistrationLogin />
              </SelfRegistration>
            }
          />
          <Route
            path="inscripcion-digital"
            element={
              <SelfRegistration>
                <DigitalRegistrationPage registrationType="otherReg" />
              </SelfRegistration>
            }
          />
          <Route
            path="/auto-gestion/metodo-pago"
            element={
              <SelfRegistration>
                <PaymentMethod />
              </SelfRegistration>
            }
          />
          <Route
            path="/auto-gestion/bienvenida"
            element={
              <SelfRegistration>
                <WelcomeToNovaventa />
              </SelfRegistration>
            }
          />
          <Route path="*" element={<Navigate to="/auto-gestion" />} />
        </Route>

        <Route path="llamada-experto">
          <Route index element={<Navigate to="/llamada-experto/login-documento" />} />
          <Route
            path="login-documento"
            element={
              <ExpertCall>
                <ExpertCallLogin navigationPath="/llamada-experto/datos-prospecto" />
              </ExpertCall>
            }
          />
          <Route
            path="datos-prospecto"
            element={
              <ExpertCall>
                <ProspectCustomerForm />
              </ExpertCall>
            }
          />
          <Route path="*" element={<Navigate to="/llamada-experto" />} />
        </Route>

        <Route path="registro-presencial">
          <Route index element={<Navigate to="/registro-presencial/login-documento" />} />

          <Route
            path="login-documento"
            element={
              <Registration path="registro-presencial">
                <IdForm
                  isProspectCustomer
                  isServant
                  navigationPath="/registro-presencial/inscripcion-digital"
                  registrationType="otherReg"
                />
              </Registration>
            }
          />
          <Route
            path="login-usuario"
            element={
              <NovaventaLayout
                deviceType={device()}
                percent={0}
                loginBanner
                headerStr={[t.constants.INICIOSESION, t.constants.INGRESACOMOASESOR, ""]}
              >
                <UserPasswordForm navigationPath="/registro-presencial/login-documento" />
              </NovaventaLayout>
            }
          />

          <Route
            path="inscripcion-digital"
            element={
              <Registration path="registro-presencial">
                <DigitalRegistrationPage registrationType="otherReg" />
              </Registration>
            }
          />

          <Route
            path="metodo-pago"
            element={
              <Registration path="registro-presencial">
                <PaymentMethod />
              </Registration>
            }
          />
          <Route
            path="bienvenida"
            element={
              <Registration path="registro-presencial">
                <WelcomeToNovaventa />
              </Registration>
            }
          />

          {/* <Route path="*" element={<Navigate to="/registro-presencial" />} /> */}
        </Route>

        <Route path="registro-telefonico">
          <Route index element={<Navigate to="/registro-telefonico/login-documento" />} />
          <Route
            path="login-usuario"
            element={
              <NovaventaLayout
                deviceType={device()}
                percent={0}
                loginBanner
                headerStr={[t.constants.INICIOSESION, t.constants.INGRESACOMOASESOR, ""]}
              >
                <UserPasswordForm navigationPath="/registro-telefonico/login-documento" />
              </NovaventaLayout>
            }
          />
          <Route
            path="login-usuario/olvide-contrasena"
            element={
              <Registration path="registro-telefonico">
                <ForgotPassword navigationPath="/registro-telefonico/login-usuario/cambio-contrasena" />
              </Registration>
            }
          />
          <Route
            path="login-usuario/cambio-contrasena"
            element={
              <Registration path="registro-telefonico">
                <ChangePasswordForm navigationPath="/registro-telefonico/login-usuario" />
              </Registration>
            }
          />
          <Route
            path="login-usuario/activar-pass"
            element={
              <Registration path="registro-telefonico">
                <ActivePasswordForm />
              </Registration>
            }
          />
          <Route
            path="login-documento"
            element={
              <Registration path="registro-telefonico">
                <IdForm
                  isServant
                  navigationPath="/registro-telefonico/inscripcion-digital"
                  registrationType="phoneReg"
                />
              </Registration>
            }
          />
          <Route
            path="inscripcion-digital"
            element={
              <Registration path="registro-telefonico">
                <DigitalRegistrationPage registrationType="phoneReg" />
              </Registration>
            }
          />
          <Route
            path="subir-documento"
            element={
              <Registration path="registro-telefonico">
                <UploadImagePage />
              </Registration>
            }
          />

          <Route
            path="metodo-pago"
            element={
              <Registration path="registro-telefonico">
                <PaymentMethod />
              </Registration>
            }
          />
          <Route
            path="bienvenida"
            element={
              <Registration path="registro-telefonico">
                <WelcomeToNovaventa />
              </Registration>
            }
          />
          <Route path="*" element={<Navigate to="/registro-telefonico" />} />
        </Route>

        <Route path="contado-credito">
          <Route
            path="retoma/:base64"
            element={
              <Registration path="contado-credito">
                <RetakesCredit />
              </Registration>
            }
          />
        </Route>

        <Route path="cupo-demanda">
          <Route
            path="validar/:ciclo/:data"
            element={
              <Registration path="cupo-demanda">
                <CreditOnDemand />
              </Registration>
            }
          />
        </Route>

        <Route path="admin">
          <Route index element={<Navigate to="/admin/gestion" />} />
          <Route
            path="login-usuario"
            element={
              <Registration path="admin">
                <UserPasswordForm navigationPath="/admin/gestion" />
              </Registration>
            }
          />

          <Route
            path="login-usuario"
            element={
              <Registration path="admin">
                <UserPasswordForm navigationPath="/admin/gestion" />
              </Registration>
            }
          />
          <Route
            path="login-usuario/olvide-contrasena"
            element={
              <Registration path="admin">
                <ForgotPassword navigationPath="/registro-telefonico/login-usuario/cambio-contrasena" />
              </Registration>
            }
          />
          <Route path="gestion">
            <Route
              index
              element={
                <Registration path="admin">
                  <MenuAdmin />
                </Registration>
              }
            />
            <Route
              path="listas-internas"
              element={
                <Registration path="admin">
                  <InternalList />
                </Registration>
              }
            />
            <Route
              path="descargar-documentos"
              element={
                <Registration path="admin">
                  <DownloadDocuments />
                </Registration>
              }
            />
            <Route
              path="historial-proceso"
              element={
                <Registration path="admin">
                  <HistoryProcess />
                </Registration>
              }
            />
            <Route
              path="consultar-proceso"
              element={
                <Registration path="admin">
                  <ConsultProcess />
                </Registration>
              }
            />
            <Route
              path="lista-negra-correos"
              element={
                <Registration path="admin">
                  <EmailBlacklist />
                </Registration>
              }
            />
            <Route
              path="carga-documentos"
              element={
                <Registration path="admin">
                  <UploadDocuments />
                </Registration>
              }
            />
            <Route
              path="llamadas"
              element={
                <Registration path="admin">
                  <Calls />
                </Registration>
              }
            />
            <Route
              path="integraciones"
              element={
                <Registration path="admin">
                  <Integrations />
                </Registration>
              }
            />
          </Route>
          {/* <Route path="*" element={<Navigate to="/admin" />} /> */}
        </Route>

        {/* <Route path="*" element={<Navigate to="/" />} /> */}
      </Routes>
    </BrowserRouter>
  );
};
